export const SET_ALL_REPORTS = 'SET_ALL_REPORTS'
export const SELECT_REPORT = 'SELECT_REPORT'
export const SET_UUID_REPORT='SET_UUID_REPORT'